const API_URL = '/tools-api.php';

export const requestCallback = async ({ name, phone, comment = '', toolName = '', recommended = [], rentalTerm = '' }) => {
  const res = await fetch(`${API_URL}?action=request-callback`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, phone, comment, toolName, recommended, rentalTerm }),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to send request');
  return data;
};
